(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name crewing.factory:CrewingAdaptor
     *
     * @description
     *
     */
    angular
        .module('crewing')
        .factory('CrewingAdaptor', CrewingAdaptor);

    function CrewingAdaptor(MessageService, applicationConstants, CommonLogicService) {

        var getFlightDetails = function (flightLegDetails, type) {
            var getObjCol = function (flightLegDetails, type) {
                var flights = [];

                angular.forEach(flightLegDetails, function (obj) {
                    var adapted;
                    if (type == 'FLIGHT') {
                        adapted = {
                            id: obj.flightLegId,
                            flightSlotEvent: obj.flightLegNo,
                            typePreCategory: null,
                            depLoc: obj.origin,
                            startTime: obj.estDepartureDateStr + ' ' + obj.estDepartureTimeStr,
                            startTimeObj: moment(obj.estDepartureDateStr + ' ' + obj.estDepartureTimeStr, "DD/MM/YYYY HH:mm").toDate(),
                            arrLoc: obj.destination,
                            endTime: obj.estArrivalDateStr + ' ' + obj.estArrivalTimeStr,
                            endTimeObj: moment(obj.estArrivalDateStr + ' ' + obj.estArrivalTimeStr, "DD/MM/YYYY HH:mm").toDate(),
                            trainingPro: obj.trainingProgramCode,
                            progDetails: obj.trainingProgramDescription,
                            pic: obj.isPIC,
                            fam: obj.isFam,
                            type : 'FLIGHT'
                        };
                    } else if(type == 'TRAINING'){
                        adapted = {
                            id: obj.trainingSlotId,
                            flightSlotEvent: obj.trainingSlot,
                            typePreCategory: obj.trainingProgramCatCode,
                            depLoc: obj.trainingLocation,
                            startTime: obj.trainingFromDateStr + ' ' + obj.trainingFromTimeStr,
                            startTimeObj: moment(obj.trainingFromDateStr + ' ' + obj.trainingFromTimeStr, "DD/MM/YYYY HH:mm").toDate(),
                            arrLoc: null,
                            endTime: obj.trainingToDateStr + ' ' + obj.trainingToTimeStr,
                            endTimeObj: moment(obj.trainingToDateStr + ' ' + obj.trainingToTimeStr, "DD/MM/YYYY HH:mm").toDate(),
                            trainingPro: obj.trainingProgramCode,
                            progDetails: obj.subProgramCode,
                            type : 'TRAINING'
                        };
                    }else{
                    	adapted = {
                                id: obj.eventId,
                                flightSlotEvent: obj.flightNumber ? obj.eventCode + "(" + obj.flightNumber + ")" : obj.eventCode,
                                typePreCategory: obj.trainingProgramCatCode,
                                depLoc: obj.startLocation,
                                startTime: obj.startDateStr + ' ' + obj.startTimeStr,
                                startTimeObj: moment(obj.startDateStr + ' ' + obj.startTimeStr, "DD/MM/YYYY HH:mm").toDate(),
                                arrLoc: obj.endLocation,
                                endTime: obj.endDateStr + ' ' + obj.endTimeStr,
                                endTimeObj: moment(obj.endDateStr + ' ' + obj.endTimeStr, "DD/MM/YYYY HH:mm").toDate(),
                                trainingPro: '',
                                progDetails: '',
                                type : 'EVENT'
                            };

                    }
                    flights.push(adapted);
                });
                return flights;
            };

            return getObjCol(flightLegDetails, type);
        };


        var getCrewDetails = function (crewCol) {
            var fieldNames = [
                {
                    label: 'Crew Id',
                    fieldNames: 'crewId'
                },
                {
                    label: 'Crew Type',
                    fieldNames: 'crewType'
                },
                {
                    label: 'Crew Name',
                    fieldNames: 'crewName'
                },
                {
                    label: 'Trainee/Trainer',
                    fieldNames: null
                }
            ];
            var adapted = [];
            if (!!crewCol) {
                var tmp;
                angular.forEach(fieldNames, function (obj) {
                    tmp = {
                        fieldName: obj.label,
                        fieldValues: _.map(crewCol, function (crew) {
                            var t = {};
                            t.field_0 = crew[obj.fieldNames];
                            t.crewProfileId = crew.crewProfileId;
                            return t;
                        })
                    };
                    adapted.push(tmp);
                });
            }
            return adapted;
        };

        var getBlockDetailAdaptor = function (response) {
            var adapted = response.scheduleBlockDetail;
            if (adapted.scheduleFlightLegDetails.length > 0) {
                adapted.blockType = 'FLIGHT';
                adapted.dutyHoursFormatted = CommonLogicService.getHoursByMinutes(adapted.dutyHours);
                adapted.flyingHoursFormatted = CommonLogicService.getHoursByMinutes(adapted.flyingHours);
                adapted.origin = adapted.scheduleFlightLegDetails[0].origin;
                adapted.destination = adapted.scheduleFlightLegDetails[adapted.scheduleFlightLegDetails.length - 1].destination;
                adapted.adaptedFlightEventDetails = getFlightDetails(adapted.scheduleFlightLegDetails, adapted.blockType);
                if(adapted.scheduleEventScheduleDetails.length > 0){
                	adapted.blockType = 'EVENT';
                	var eventDetailArr=getFlightDetails(adapted.scheduleEventScheduleDetails, adapted.blockType);
                	angular.forEach(eventDetailArr, function (eventDetail){
                		adapted.adaptedFlightEventDetails.push(eventDetail)
                	})
                }
                adapted.blockType = 'FLIGHT';
                //adapted.adaptedFlightEventDetails = adapted.scheduleFlightLegDetails;
                //adapted.adaptedAssignedCrewDetails = getCrewDetails(adapted.assignedCrewDetailDTOs);
                adapted.adaptedAssignedCrewDetails = adapted.assignedCrewDetailDTOs;
            } else if (adapted.scheduleTrainingDetails.length > 0) {
                adapted.blockType = 'TRAINING';
                adapted.dutyHoursFormatted = CommonLogicService.getHoursByMinutes(adapted.dutyHours);
                adapted.flyingHoursFormatted = CommonLogicService.getHoursByMinutes(adapted.flyingHours);
                adapted.origin = adapted.scheduleTrainingDetails[0].trainingLocation;
                adapted.destination = '';
                adapted.adaptedFlightEventDetails = getFlightDetails(adapted.scheduleTrainingDetails, adapted.blockType);
                adapted.adaptedAssignedCrewDetails = adapted.assignedCrewDetailDTOs;
            }else if (adapted.scheduleEventScheduleDetails.length > 0) {
                adapted.blockType = 'EVENT';
            }

            return adapted;
        };

      var getBlockDetailTrainingAdaptor = function (response) {
        var adaptedResponseList = [];
        angular.forEach(response, function (result) {
          var adapted = result.scheduleBlockDetail;
          if (adapted.scheduleTrainingDetails.length > 0) {
            adapted.blockType = 'TRAINING';
            adapted.dutyHoursFormatted = CommonLogicService.getHoursByMinutes(adapted.dutyHours);
            adapted.flyingHoursFormatted = CommonLogicService.getHoursByMinutes(adapted.flyingHours);
            adapted.origin = adapted.scheduleTrainingDetails[0].trainingLocation;
            adapted.destination = '';
            adapted.adaptedFlightEventDetails = getFlightDetails(adapted.scheduleTrainingDetails, adapted.blockType);
            adapted.adaptedAssignedCrewDetails = adapted.assignedCrewDetailDTOs;

            adaptedResponseList.push(adapted.scheduleTrainingDetails[0]);
          }

        });
        return adaptedResponseList;
      };


        var getBlockDetailAdaptorForCrewSchedule = function (response) {

        	var adapted = response.scheduleBlockDetail;
        	if(!response.scheduleBlockDetail.singleEventParing){

	            adapted.blockType = 'FLIGHT';
	            adapted.dutyHoursFormatted = CommonLogicService.getHoursByMinutes(adapted.dutyHours);
	            adapted.flyingHoursFormatted = CommonLogicService.getHoursByMinutes(adapted.flyingHours);
	            adapted.origin = adapted.blockStartLocation;
	            adapted.destination = adapted.blockEndLocation;;
	            adapted.adaptedFlightEventDetails = [];

	            if (adapted.scheduleFlightLegDetails.length > 0){
	                var eventDetailArr = getFlightDetails(adapted.scheduleFlightLegDetails, 'FLIGHT');
	                angular.forEach(eventDetailArr, function (eventDetail){
	            		adapted.adaptedFlightEventDetails.push(eventDetail);
	            	});
	            }

	            if(adapted.scheduleEventScheduleDetails.length > 0){
	            	//adapted.blockType = 'EVENT';
	                var eventDetailArr=getFlightDetails(adapted.scheduleEventScheduleDetails, 'EVENT');
	            	angular.forEach(eventDetailArr, function (eventDetail){
	            		adapted.adaptedFlightEventDetails.push(eventDetail);
	            	});
	            }

	            if(adapted.scheduleTrainingDetails.length > 0){
	            	adapted.blockType = 'TRAINING';
	                var eventDetailArr=getFlightDetails(adapted.scheduleTrainingDetails, 'TRAINING');
	                angular.forEach(eventDetailArr, function (eventDetail){
	            		adapted.adaptedFlightEventDetails.push(eventDetail);
	            	});
	            }

	            adapted.adaptedAssignedCrewDetails = adapted.assignedCrewDetailDTOs;
              adapted.flightTrainingAssignedCrew = [];
              angular.forEach(adapted.scheduleFlightLegDetails, function (flightDetail){
                var assignedCrewForFlightAsTrainerTrainee = {};
                assignedCrewForFlightAsTrainerTrainee.flightLegId = flightDetail.flightLegId;
                assignedCrewForFlightAsTrainerTrainee.crewList = flightDetail.assignedCrewTrainingDetails;
                adapted.flightTrainingAssignedCrew.push(assignedCrewForFlightAsTrainerTrainee);
              });

        	}else{

        		adapted.adaptedFlightEventDetails = [];

        		if(adapted.scheduleEventScheduleDetails.length > 0) {
            		 adapted.blockType = 'EVENT';
            	} else if (adapted.scheduleTrainingDetails.length > 0) {
                    adapted.blockType = 'TRAINING';
                    adapted.dutyHoursFormatted = CommonLogicService.getHoursByMinutes(adapted.dutyHours);
                    adapted.flyingHoursFormatted = CommonLogicService.getHoursByMinutes(adapted.flyingHours);
                    adapted.origin = adapted.scheduleTrainingDetails[0].trainingLocation;
                    adapted.destination = '';
                    adapted.adaptedFlightEventDetails = getFlightDetails(adapted.scheduleTrainingDetails, adapted.blockType);
                    adapted.adaptedAssignedCrewDetails = adapted.assignedCrewDetailDTOs;
                }

        	}

            return adapted;
        };

        function convertDateDifferenceToHoursAndMinutesFormat(datetimeLocal, datetimeZulu) {
          if (!datetimeLocal || !datetimeZulu) {
            return ""
          }
          var localDate = moment(datetimeLocal, "DD/MM/YYYY HH:mm");
          var zuluDate = moment(datetimeZulu, "DD/MM/YYYY HH:mm");

          var diffMinutes = localDate.diff(zuluDate, "minutes");

          // absolute values
          var absMinutes = Math.abs(diffMinutes);
          var hours = Math.floor(absMinutes / 60);
          var minutes = absMinutes % 60;

          function pad(num) {
            return num < 10 ? "0" + num : "" + num;
          }
          var formattedTime = pad(hours) + ":" + pad(minutes);
          var sign = diffMinutes >= 0 ? "+" : "-";
          return sign + formattedTime;
        }

        function getDayDifferenceString(datetimeLocal, datetimeZulu) {
          if (!datetimeLocal || !datetimeZulu) {
            return ""
          }
          var d1 = moment(datetimeLocal, "DD/MM/YYYY HH:mm");
          var d2 = moment(datetimeZulu, "DD/MM/YYYY HH:mm");

          var diffDays = d2.startOf("day").diff(d1.startOf("day"), "days");
          if (diffDays === 0) {
            return 0;
          }
          return (diffDays > 0 ? "+" : "") + diffDays;
        }

        var getBlock = function (duty, type) {
            if (type == 'REST') {
                var rest = {};
                rest.type = 'REST';
                rest.restStartDate = duty.restStartDate;
                rest.restStartTime = duty.restStartTime;
                rest.restEndDate = duty.restEndDate;
                rest.restEndTime = duty.restEndTime;
                rest.restStartDateZulu = duty.restStartDateZulu;
                rest.restStartTimeZulu = duty.restStartTimeZulu;
                rest.restEndDateZulu = duty.restEndDateZulu;
                rest.restEndTimeZulu = duty.restEndTimeZulu;
                rest.hoursAndMinutesDiff = convertDateDifferenceToHoursAndMinutesFormat(
                  duty.restStartDate + " " + duty.restStartTime, duty.restStartDateZulu + " " + duty.restStartTimeZulu);
                rest.restStartDayDiff = getDayDifferenceString(
                  duty.restStartDate + " " + duty.restStartTime, duty.restStartDateZulu + " " + duty.restStartTimeZulu);
                rest.restEndDayDiff = getDayDifferenceString(
                  duty.restEndDate + " " + duty.restEndTime, duty.restEndDateZulu + " " + duty.restEndTimeZulu);

                if (duty.evenCode == 'LAY') {
                  rest.eventCode = 'LAY';
                }
                rest.minRest = duty.eventMinimumRest;
                return rest;
            } else if (type == 'DUTY') {
                duty.type = 'DUTY';
                duty.hoursAndMinutesDiff = convertDateDifferenceToHoursAndMinutesFormat(
                  duty.checkInDate + " " + duty.checkInTime, duty.checkInDateZulu + " " + duty.checkInTimeZulu);
                duty.checkInDayDiff = getDayDifferenceString(
                  duty.checkInDate + " " + duty.checkInTime, duty.checkInDateZulu + " " + duty.checkInTimeZulu);
                duty.checkOutDayDiff = getDayDifferenceString(
                  duty.checkOutDate + " " + duty.checkOutTime, duty.checkOutDateZulu + " " + duty.checkOutTimeZulu);
                return duty;
            }
        };

        var addCrewInfoToBlock = function (block, crewDTO) {
            block.crewInfo = {
                crewProfileId: crewDTO.crewProfileId,
                crewId: crewDTO.crewId,
                hubCode: crewDTO.hubCode,
                employerHub: crewDTO.employerHub,
                crewTypeCode: crewDTO.crewTypeCode,
                crewTypeMasterCode: crewDTO.crewTypeMasterCode,
                firstName: crewDTO.firstName,
                lastName: crewDTO.lastName,
                trainerTypeCode: crewDTO.trainerTypeCode
            };
            return block;
        };

        var getAdaptedRegulationMap = function (regulationMap) {
            var adaptedRegulationMap = [];

            var isViolated = function (regulations) {
                var found = _.find(regulations, function (obj) {
                    return !obj.legalDay1 || !obj.legalDay2
                });
                if (!!found) {
                    return true;
                } else {
                    return false;
                }
            };

            if (!!regulationMap) {
                angular.forEach(Object.keys(regulationMap), function (key) {
                    adaptedRegulationMap.push({
                        regulationBlockName: key,
                        isViolated: isViolated(regulationMap[key]),
                        regulations: regulationMap[key]
                    });
                });
            }
            return adaptedRegulationMap;
        };

        var getBlockAssignedCrewAdaptor = function (response) {
            var dtos = response.assignedCrewDTOs;
            var adapted = '';
            angular.forEach(dtos, function (crew, index) {
                if (index != 0) {
                    adapted += ',';
                }
                adapted += crew.crewId;
            });
            return adapted;
        };

        var getCopyPasteDutyAdaptor = function (response) {
            response.adaptedRegulationMap = getAdaptedRegulationMap(response.regulationMap);
            return response;
        };

        var getCutPasteDutyAdaptor = function (response) {
            response.adaptedRegulationMap = getAdaptedRegulationMap(response.regulationMap);
            return response;
        };

        var getHistoryAdaptor = function (response) {
            return response.historyDTOs;
        };

        var getRegulationAdaptor = function (response) {
            response.adaptedRegulationMap = getAdaptedRegulationMap(response.regulationMap);
            return response;
        };

        var getFlightOccurringEventsAdaptor = function (response) {
            return response.flightEventDTOs;
        };

        var getAssignEventAdaptor = function (response) {
            response.adaptedRegulationMap = getAdaptedRegulationMap(response.regulationMap);
            return response;
        };

        var getAssignTrainingAdaptor = function (response) {
            response.adaptedRegulationMap = getAdaptedRegulationMap(response.regulationMap);
            return response;
        };

        var getEventsAdaptor = function (response) {
            var adapted;
            adapted = _.groupBy(response.eventViewDTOs, 'eventCategoryCode');
            return adapted;
        };

        var getTrainingsAdaptor = function (responseObj) {
            var toSend = [];
            if (responseObj.hasOwnProperty('trainingResponseDTOs') && responseObj.trainingResponseDTOs.length > 0) {
                toSend = responseObj.trainingResponseDTOs;
            } else {
                MessageService.warning(MessageService.MESSAGES.COMMON.NO_RECORDS_FOUND);
            }
            return toSend;
        };

        var getAssignPatternAdaptor = function (response) {
            response.adaptedRegulationMap = getAdaptedRegulationMap(response.regulationMap);
            return response;
        };

        var getPatternByIdAdaptor = function (response) {
            var adapted = response.pattern;
            angular.forEach(adapted.blockList, function (block) {
                angular.forEach(block.blockDetailList, function (detail) {
                    detail.type = '';
                    if (!!detail.flightLegId) {
                        detail.type = 'FLIGHT';
                        detail.header = detail.flightNo;
                        detail.iconClass = 'flight';
                        detail.leftLblOne = detail.startLocation;
                        detail.leftLblTwo = detail.startTimeStr;
                        detail.rightLblOne = detail.endLocation || " ";
                        detail.rightLblTwo = detail.endTimeStr || " ";
                    } else if (!!detail.trainingId) {
                        detail.type = 'TRAINING';
                        detail.header = detail.eventCode;
                        detail.iconClass = 'flight';
                        detail.leftLblOne = detail.startLocation;
                        detail.leftLblTwo = detail.startTimeStr;
                        detail.rightLblOne = detail.endLocation || " ";
                        detail.rightLblTwo = ddetail.endTimeStr || " ";
                    } else if (!!detail.eventId) {
                        if (detail.eventCode == 'RST') {
                            detail.type = 'REST';
                            detail.isRest = true;
                        } else if (detail.type == 'OFF') {
                            detail.type = 'OFF';
                            detail.iconClass = 'weekend';
                        } else {
                            detail.type = 'EVENT';
                            detail.iconClass = 'event';
                        }
                        detail.header = detail.eventCode;
                        detail.leftLblOne = detail.startLocation;
                        detail.leftLblTwo = detail.startTimeStr;
                        detail.rightLblOne = detail.endLocation || " ";
                        detail.rightLblTwo = detail.endTimeStr || " ";
                    }
                });
            });
            return adapted;
        };

        var getSwapResponseAdaptor = function (response, adaptedCrewSchedule) {
            response.crewWiseRegulationMap = [];
            if (!!response.responseMap) {
                var crew;
                var tmp;
                angular.forEach(Object.keys(response.responseMap), function (crewProfileId) {
                    crew = _.findWhere(adaptedCrewSchedule.nameCollection, {crewProfileId: parseInt(crewProfileId)});
                    tmp = response.responseMap[crewProfileId];
                    tmp.groupFieldOne = crewProfileId;
                    tmp.groupFieldTwo = (crew && crew.name) || '';
                    tmp.adaptedRegulationMap = getAdaptedRegulationMap(tmp.regulationMap);
                    response.crewWiseRegulationMap.push(tmp);
                });
            }
            return response;
        };


        var getSearchPatternDataAdaptor = function (response) {
            return response;
        };

        var getSearchOpenPairingsAdaptor = function (response, searchParam) {
            var getFormattedBlocks = function (tCol) {
                var tmp = [];
                angular.forEach(tCol, function (block) {
                    tmp.push(getBlock(block, 'DUTY'));
                    if (!!block.restStartDate) {
                        tmp.push(getBlock(block, 'REST'));
                    }
                });
                return tmp;
            };

            var getCrewRequirement = function (pattern) {
                var req = '';
                if (pattern && pattern.crewInfo) {
                    angular.forEach(pattern.crewInfo, function (crew,index) {
                        if(index != 0){
                            req += ' | ';
                        }
                        req += (crew.crewType + ':' + crew.assignedCrew + '/' + crew.requiredCrew);
                    })
                }
                return req;
            };

            var getACType = function (pattern) {
                var acTypes = [];
                for (var duty in pattern){
                    if(acTypes.indexOf(pattern[duty].acType)==-1){
                        acTypes.push(pattern[duty].acType);
                    }
                }
                return acTypes.toString();
            }

            var getPairing = function (tmp) {
                var result = [];
                angular.forEach(Object.keys(tmp), function (patternID) {
                    var tCol = _.sortBy(tmp[patternID], function (obj) {
                        return moment(obj.checkInDate, applicationConstants.SETTINGS.DATE_FORMAT)
                    });
                    var paring = {
                        patternId: patternID,
                        firstFlightFoundDate: tCol[0].firstFlightFoundDate,
                        patternStartDate: tCol[0].patternStartDate,
                        patternStartTime: tCol[0].checkInTime,
                        ptnEndDate: tCol[0].patternEndDate,
                        ptnEndTime: tCol[0].patternEndTime,
                        patternName: tCol[0].patternName,
                        crewRequirment: getCrewRequirement(tCol[0]),
                        duration : tCol[0].duration,
                        acModels:getACType(tCol)
                    };

                    if (!!tCol[0].restEndDate) {
                        paring.patternEndDate = tCol[tCol.length - 1].restEndDate;
                        paring.patternEndTime = tCol[tCol.length - 1].restEndTime;
                    } else {
                        paring.patternEndDate = tCol[tCol.length - 1].checkOutDate;
                        paring.patternEndTime = tCol[tCol.length - 1].checkOutTime;
                    }

                    paring.events = getFormattedBlocks(tCol);
                    result.push(paring);
                });
                return result;
            };

            var tmp = _.groupBy(response.openBlocks, 'patternId');
            var allParings = getPairing(tmp);
            var groupByDate = _.groupBy(allParings, 'firstFlightFoundDate');
            var nonOverLappedCol = avoidOverlap(groupByDate);


            function updateMinMax(yCol, index, start, end) {
                if (angular.isUndefined(yCol[index])) {
                    yCol[index] = {};
                }

                if (angular.isUndefined(yCol[index].minDate) || start < yCol[index].minDate) {
                    yCol[index].minDate = start;
                }

                if (angular.isUndefined(yCol[index].maxDate) || end > yCol[index].maxDate) {
                    yCol[index].maxDate = end;
                }
            }


            function getRowIndex(rowMinMax, start, end) {
                var obj;
                var rowIndex = -1;
                for (var i = 0; i < rowMinMax.length; i++) {
                    obj = rowMinMax[i];
                    if (
                        (end.isSameOrBefore(rowMinMax[i].minDate, 'minute')) || (start.isSameOrAfter(rowMinMax[i].maxDate, 'minute'))
                    ) {
                        updateMinMax(rowMinMax, i, start, end);
                        rowIndex = i;
                        break;
                    }
                }

                if (rowIndex == -1) {
                    rowIndex = rowMinMax.length;
                    updateMinMax(rowMinMax, rowIndex, start, end);
                }
                return rowIndex;
            }


            function avoidOverlap(groupByDate) {
                var rowMinMax = [];
                var tmpMomentStart;
                var tmpMomentEnd;

                angular.forEach(Object.keys(groupByDate), function (dateKey) {
                    angular.forEach(groupByDate[dateKey], function (pattern) {
                        tmpMomentStart = moment(pattern.patternStartDate + ' ' + pattern.patternStartTime, applicationConstants.SETTINGS.DATE_TIME_FORMAT);
                        tmpMomentEnd = moment(pattern.patternEndDate + ' ' + pattern.patternEndTime, applicationConstants.SETTINGS.DATE_TIME_FORMAT);
                        pattern.rowIndex = getRowIndex(rowMinMax, tmpMomentStart, tmpMomentEnd);
                    });
                });
                return groupByDate;
            }


            var adapted = {
                startDate: searchParam.startDate,
                endDate: searchParam.endDate,
                openBlocks: nonOverLappedCol
            };
            return adapted;
        };

        var getCrewCategoryAdaptor = function (response) {
            var adapted = [];
            if (!!response) {
                angular.forEach(Object.keys(response), function (key) {
                    adapted.push(
                        {
                            'categoryCode': key,
                            'description': response[key]
                        }
                    );
                });
            }
            return adapted;
        };

        var getCrewGroupAdaptor = function (response) {
            return response.crewGroups;
        };

        function convertMinutesToHours(minutes) {
            var H = Math.floor(minutes / 60);
            var M = minutes % 60;
            if (M < 10) {
                M = '0' + M;
            }
            return H + ':' + M;
        }

        /**
         * Crew Schedule response data adaptor
         * @param data
         * @returns {{}}
         */
        var getSearchCrewScheduleAdaptor = function (data, searchParams) {
            var fromDate = moment(searchParams.fromDate, applicationConstants.SETTINGS.DATE_FORMAT);
            var toDate = moment(searchParams.toDate, applicationConstants.SETTINGS.DATE_FORMAT);

          var adaptedCrewSchedules = [];
          angular.forEach(data.crewScheduleDTOs, function (dto, index) {
            //if(dto.rosterDutyDTOs.length > 0) {
              adaptedCrewSchedules.push(dto);
            //}
          });

            var adapted = {};

            adapted.publishFromDate = data.publishFromDate;
            adapted.publishToDate = data.publishToDate;
            adapted.startPosition = data.startPosition;
            adapted.totalRecords = data.totalRecords;
            adapted.schedule = adaptedCrewSchedules;

            var getPattern = function (duty) {
                var pattern = {};
                pattern.eventType = 'PATTERN';
                pattern.events = [];
                pattern.patternId = duty.patternId;
                pattern.patternStartDate = duty.patternStartDate || duty.checkInDate;
                pattern.patternStartTime = duty.patternStartTime || duty.checkInTime;
                if(!!duty.patternStartDateZulu){
                	pattern.patternStartDateZulu = duty.patternStartDateZulu;
                }
                if(!!duty.patternEndDateZulu){
                	pattern.patternEndDateZulu = duty.patternEndDateZulu;
                }
                if(!!duty.pairingBase){
                	pattern.pairingBase = duty.pairingBase;
                }
                pattern.patternName = duty.patternName;
                pattern.illegalDistIdentifier = duty.illegalDistIdentifier;
                pattern.scheduleIndex = moment(pattern.patternStartDate, applicationConstants.SETTINGS.DATE_FORMAT).diff(fromDate, 'days');
                if(pattern.scheduleIndex < 0){
                	pattern.scheduleIndex  = 0;
                }
                return pattern;
            };

            var getNewPattern = function (duty) {
                var pattern = getPattern(duty);
                pattern.events.push(getBlock(duty, 'DUTY'));

                pattern.endDateWithoutRest = duty.patternEndDate === null ? duty.checkOutDate :duty.patternEndDate;
                pattern.endTimeWithoutRest = duty.patternEndTime === null ? duty.checkOutTime :duty.patternEndTime;

                if (!!duty.restStartDate) {
                    pattern.events.push(getBlock(duty, 'REST'));
                    if (moment(duty.patternEndDate + " " + duty.patternEndTime, 'DD/MM/YYYY HH:mm').diff(moment(duty.restEndDate + " " + duty.restEndTime, 'DD/MM/YYYY HH:mm')) >= 0) {
                		pattern.patternEndDate = duty.patternEndDate;
                		pattern.patternEndTime = duty.patternEndTime;
                	} else {
                		pattern.patternEndDate = duty.restEndDate;
                		pattern.patternEndTime = duty.restEndTime;
                	}
                } else {
                	if (moment(duty.patternEndDate + " " + duty.patternEndTime, 'DD/MM/YYYY HH:mm').diff(moment(duty.checkOutDate + " " + duty.checkOutTime, 'DD/MM/YYYY HH:mm')) >= 0) {
                		pattern.patternEndDate = duty.patternEndDate;
                		pattern.patternEndTime = duty.patternEndTime;
                	} else {
                		pattern.patternEndDate = duty.checkOutDate;
                		pattern.patternEndTime = duty.checkOutTime;
                	}
                }
                if(!!duty.patternStartDateZulu){
                	pattern.patternStartDateZulu = duty.patternStartDateZulu;
                }
                if(!!duty.patternEndDateZulu){
                	pattern.patternEndDateZulu = duty.patternEndDateZulu;
                }

                if(!!duty.pairingBase){
                	pattern.pairingBase = duty.pairingBase;
                }
                return pattern;
            };

            var getTrainerCode = function (crewDTO) {
                var codes = [];
                if (crewDTO.trainerTypeDTOs) {
                    angular.forEach(crewDTO.trainerTypeDTOs, function (trainer) {
                        codes.push(trainer.trainerTypeCode);
                    });
                }
                return codes.toString();
            };

            var addAsIconType = function (adaptedRosterDutyDTOs, eventObt, type) {
                var eventObjDate;
                var iconObj;
                if (type == 'MEMO') {
                    eventObjDate = eventObt.memoDate;
                } else if (type == 'ALERT') {
                    eventObjDate = eventObt.alertDate;
                } else if (type == 'EXPIRY') {
                    eventObjDate = eventObt.dateOfExpiry;
                }

                var getExisting = _.find(adaptedRosterDutyDTOs, function (dto) {
                    return dto.eventType == 'ICON' && dto.eventDate == eventObjDate
                });

                if (!!getExisting) {
                    if (angular.isDefined(getExisting[type])) {
                        getExisting[type].push(eventObt);
                    } else {
                        getExisting[type] = [eventObt];
                    }
                } else {
                    iconObj = {};
                    iconObj.eventType = 'ICON';
                    iconObj.eventDate = eventObjDate;
                    iconObj[type] = [eventObt];
                    iconObj.scheduleIndex = moment(iconObj.eventDate, applicationConstants.SETTINGS.DATE_FORMAT).diff(fromDate, 'days');
                    if(iconObj.scheduleIndex < 0){
                    	iconObj.scheduleIndex  = 0;
                    }
                    adaptedRosterDutyDTOs.push(iconObj);
                }
            };

            adapted.nameCollection = [];
            var tmpCrewInfo;
            angular.forEach(adapted.schedule, function (dto, index) {
              /*prepare crew name collection*/
              tmpCrewInfo = {
                nameIndex: parseInt(searchParams.startPosition) + index,
                name: (dto.crewDTO && dto.crewDTO.firstName) + ' ' + (dto.crewDTO && dto.crewDTO.lastName),
                flyingDuration: dto.crewDTO && dto.crewDTO.flyingDuration && convertMinutesToHours(dto.crewDTO.flyingDuration),
                dutyDuration: dto.crewDTO && dto.crewDTO.dutyDuration && convertMinutesToHours(dto.crewDTO.dutyDuration),
                fleetExperince: dto.crewDTO.fleetExperince,
                crewId: dto.crewDTO.crewId,
                hubCode: dto.crewDTO.hubCode,
                employerHub: dto.crewDTO.employerHub,
                crewTypeCode: dto.crewDTO.crewTypeCode,
                gender: dto.crewDTO.gender,
                crewProfileId: dto.crewDTO.crewProfileId,
                mobileNo: dto.crewDTO.mobileNo,
                offCount: dto.crewDTO.offCount,
                nightCount: dto.crewDTO.nightCount,
                targetDuration: Math.abs(dto.crewDTO.targetDuration),
                trainerTypeCode: getTrainerCode(dto.crewDTO),
                crewExpiry: dto.crewDTO.crewExpiryDTOs,
                hasDefaultLanguage: dto.crewDTO.hasDefaultLanguage,
                fleetExperinces: dto.crewDTO.crewFleetExperiences,
                hasLegalityViolations: !!_.findWhere(dto.rosterDutyDTOs, {legal: false})
              };
              adapted.nameCollection.push(tmpCrewInfo);

              /*prepare patterns*/
              dto.crewId = dto.crewDTO.crewId;
              dto.crewType = dto.crewDTO.crewTypeCode;
              dto.adaptedRosterDutyDTOs = [];
              var tmp;

              /*Adapt roster Duty */
              angular.forEach(dto.rosterDutyDTOs, function (duty) {

                var previousPatternEnd = null;

                angular.forEach(dto.crewDTO.crewFleetExperiences, function (fleetExperience) {
                  if (duty.patternType == "FLIGHT" && duty.aircraftType == fleetExperience['fleet'] && fleetExperience['blueLine']) {
                    duty.blueLine = true;
                  }
                })

                addCrewInfoToBlock(duty, dto.crewDTO);
                if (!!duty.patternId) {
                  tmp = _.findWhere(dto.adaptedRosterDutyDTOs, {patternId: duty.patternId});
                  if (!!tmp) {
                    if (duty.evenCode === 'LAY') {
                      tmp.isLayOver = true;
                    }
                    tmp.events.push(getBlock(duty, 'DUTY'));

                    if (!!duty.restStartDate) {
                      tmp.events.push(getBlock(duty, 'REST'));
                      if (moment(duty.patternEndDate + " " + duty.patternEndTime, 'DD/MM/YYYY HH:mm').diff(moment(duty.restEndDate + " " + duty.restEndTime, 'DD/MM/YYYY HH:mm')) >= 0) {
                        tmp.patternEndDate = duty.patternEndDate;
                        tmp.patternEndTime = duty.patternEndTime;
                      } else {
                        tmp.patternEndDate = duty.restEndDate;
                        tmp.patternEndTime = duty.restEndTime;
                      }
                    } else {
                      if (moment(duty.patternEndDate + " " + duty.patternEndTime, 'DD/MM/YYYY HH:mm').diff(moment(duty.checkOutDate + " " + duty.checkOutTime, 'DD/MM/YYYY HH:mm')) >= 0) {
                        tmp.patternEndDate = duty.patternEndDate;
                        tmp.patternEndTime = duty.patternEndTime;
                      } else {
                        tmp.patternEndDate = duty.checkOutDate;
                        tmp.patternEndTime = duty.checkOutTime;
                      }
                    }

                    if (!!duty.patternStartDateZulu) {
                      tmp.patternStartDateZulu = duty.patternStartDateZulu;
                    }
                    if (!!duty.patternEndDateZulu) {
                      tmp.patternEndDateZulu = duty.patternEndDateZulu;
                    }
                    if (!!duty.pairingBase) {
                      tmp.pairingBase = duty.pairingBase;
                    }

                  } else {
                    dto.adaptedRosterDutyDTOs.push(addOverLappinFlag(getNewPattern(duty), dto.adaptedRosterDutyDTOs));
                  }
                } else {
                  dto.adaptedRosterDutyDTOs.push(addOverLappinFlag(getNewPattern(duty), dto.adaptedRosterDutyDTOs));
                }
              });

              function addOverLappinFlag(currentPattern, allPatterns) {

                var lastItemIndex = allPatterns.length - 1;
                var lastElmt = allPatterns[lastItemIndex];

                if (!angular.isUndefined(lastElmt) && moment(lastElmt.endDateWithoutRest + " " + lastElmt.endTimeWithoutRest, 'DD/MM/YYYY HH:mm')
                    .diff(moment(currentPattern.patternStartDate + " " + currentPattern.patternStartTime, 'DD/MM/YYYY HH:mm')) >= 0) {
                  currentPattern.overlapping = true;
                } else {
                  currentPattern.overlapping = false;
                }

                return currentPattern;
              }

              /*Add events*/
              angular.forEach(dto.memoDTOs, function (memo) {
                addCrewInfoToBlock(memo, dto.crewDTO);
                memo.eventType = 'MEMO';
                addAsIconType(dto.adaptedRosterDutyDTOs, memo, 'MEMO');
              });

              /*Add Alerts*/
              angular.forEach(dto.alertsDTOs, function (alert) {
                addCrewInfoToBlock(alert, dto.crewDTO);
                alert.eventType = 'ALERT';
                addAsIconType(dto.adaptedRosterDutyDTOs, alert, 'ALERT');
              });


              /*Add Crew Expiry Details*/
              var expiryWithInSearchPeriod = _.filter(dto.crewDTO.crewExpiryDTOs, function (crewExpiryDto) {
                var mo_dateOfExpiry = moment(crewExpiryDto.dateOfExpiry, applicationConstants.SETTINGS.DATE_FORMAT);
                return mo_dateOfExpiry.isBetween(fromDate, toDate, null, '[]');
              });

              angular.forEach(expiryWithInSearchPeriod, function (expiry) {
                addCrewInfoToBlock(expiry, dto.crewDTO);
                adapted.nameCollection[index].hasExpiry = true;
                expiry.eventType = 'EXPIRY';
                addAsIconType(dto.adaptedRosterDutyDTOs, expiry, 'EXPIRY');
              });
            });
            return adapted;
        };

        var getEditEventDetailsAdaptor = function (response) {
            return response.editEventDTO;
        };

        var getUpdateTrainingProgramAdaptor = function (response) {
            return response;
        };

        var getCheckLanguageWarningAdaptor = function (response) {
            var adapted = {
                warningMessages: []
            };

            var assignedLanguageCountMap=new Map();

            angular.forEach(response.assignedCrewLangDetails, function (assignedCrewLang) {
              assignedLanguageCountMap.set(assignedCrewLang.languageCode,assignedCrewLang.count);
            });

            var getAssignmentCount = function (languageCode) {
                var assigned = [];
                angular.forEach(Object.keys(response.crewLanguageSkills), function (crewId) {
                    if (response.crewLanguageSkills[crewId].indexOf(languageCode) >= 0) {
                        assigned.push(crewId);
                    }
                });
                var languageCount=0
                if(assignedLanguageCountMap.get(languageCode)){
                  languageCount=assigned.length+assignedLanguageCountMap.get(languageCode);
                }else{
                  languageCount=assigned.length;
                }
                return languageCount;
            };

            if (response.warning) {
                angular.forEach(response.requiredCrewLangDetails, function (langObj) {
                    var assignedCount = getAssignmentCount(langObj.languageCode);
                    if (assignedCount < langObj.count) {
                        adapted.warningMessages.push(langObj.languageCode + ' No of Crews Required - ' + (langObj.count - assignedCount));
                    }
                });

                if (adapted.warningMessages.length > 0) {
                    adapted.warningMessages.splice(0, 0, 'Following Language Warnings Exist');
                }
            }
            return adapted;
        };

        var getRegulationMap = function (response) {
            var regulationDetails = [];
            angular.forEach(response, function (crew) {
                if (!!crew.adaptedRegulationMap.length) {
                    regulationDetails.push(crew.adaptedRegulationMap[0]);
                }
            });
            return regulationDetails;
        };

        var getFilterScheduleResponseAdaptor = function (response) {
            return (response && response.crewIds && response.crewIds.join(',')) || [];
        };

        var getDistViolationsAdaptor = function (response) {
            response.warningMsg = response.warnings[0];
            return {
                distIdentifier:response.distIdentifier,
                allowedDaysCount:response.allowedDaysCount,
                allowedDutiesCount:response.maxAllowed,
                currentDutiesCount:response.assigned,
                warnings: response.warnings,
                warningMsg: response.warningMsg,
                violateCurrentPtn: response.violateCurrentPtn,
                success:response.success
            };
        };

        return {
            assignEventAdaptor: getAssignEventAdaptor,
            assignTrainingAdaptor: getAssignTrainingAdaptor,
            assignPatternAdaptor: getAssignPatternAdaptor,
            blockDetailAdaptor: getBlockDetailAdaptor,
            blockDetailTrainingAdaptor: getBlockDetailTrainingAdaptor,
            getBlockDetailAdaptorForCrewSchedule : getBlockDetailAdaptorForCrewSchedule,
            blockAssignedCrewAdaptor: getBlockAssignedCrewAdaptor,
            copyPasteDutyAdaptor: getCopyPasteDutyAdaptor,
            checkLanguageWarningAdaptor: getCheckLanguageWarningAdaptor,
            cutPasteDutyAdaptor: getCutPasteDutyAdaptor,
            crewCategoryAdaptor: getCrewCategoryAdaptor,
            crewGroupAdaptor: getCrewGroupAdaptor,
            editEventDetailsAdaptor: getEditEventDetailsAdaptor,
            eventsAdaptor: getEventsAdaptor,
            filterScheduleResponseAdaptor : getFilterScheduleResponseAdaptor,
            flightOccurringEventsAdaptor: getFlightOccurringEventsAdaptor,
            historyAdaptor: getHistoryAdaptor,
            patternByIdAdaptor: getPatternByIdAdaptor,
            regulationAdaptor: getRegulationAdaptor,
            swapResponseAdaptor: getSwapResponseAdaptor,
            searchPatternDataAdaptor: getSearchPatternDataAdaptor,
            searchOpenPairingsAdaptor: getSearchOpenPairingsAdaptor,
            searchCrewScheduleAdaptor: getSearchCrewScheduleAdaptor,
            trainingsAdaptor: getTrainingsAdaptor,
            updateTrainingProgramAdaptor: getUpdateTrainingProgramAdaptor,
            getRegulationMap: getRegulationMap,
            getDistViolationsAdaptor: getDistViolationsAdaptor
        };
    }
}());
